"use client";

import { c as _c } from "react/compiler-runtime";
import FilterRadioGroup from "@modules/common/components/filter-radio-group";
export type SortOptions = "relevance" | "best_selling" | "newest" | "price_asc" | "price_desc" | "most_viewed" | "on_sale";
type SortProductsProps = {
  sortBy: SortOptions;
  setQueryParam: (name: string, value?: string) => void;
  "data-testid"?: string;
};
export const SORT_OPTIONS: Array<{
  value: SortOptions;
  label: string;
}> = [{
  value: "relevance",
  label: "Relevantes"
}, {
  value: "best_selling",
  label: "Más vendidos"
}, {
  value: "newest",
  label: "Novedades"
}, {
  value: "price_asc",
  label: "Precio: menor a mayor"
}, {
  value: "price_desc",
  label: "Precio: mayor a menor"
}, {
  value: "most_viewed",
  label: "Más vistos"
}, {
  value: "on_sale",
  label: "En oferta"
}];
const SortProducts = t0 => {
  const $ = _c(6);
  const {
    "data-testid": dataTestId,
    sortBy,
    setQueryParam
  } = t0;
  let t1;
  if ($[0] !== setQueryParam) {
    t1 = value => {
      setQueryParam("sortBy", value);
    };
    $[0] = setQueryParam;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== dataTestId || $[3] !== handleChange || $[4] !== sortBy) {
    t2 = <FilterRadioGroup title="Sort by" items={SORT_OPTIONS} value={sortBy} handleChange={handleChange} data-testid={dataTestId} />;
    $[2] = dataTestId;
    $[3] = handleChange;
    $[4] = sortBy;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default SortProducts;